export type GalleryView = "mosaic" | "carousel";

export const GALLERY_VIEWS: GalleryView[] = ["mosaic", "carousel"];

export const DEFAULT_GALLERY_VIEW: GalleryView = "mosaic";

export const GALLERY_MAX_ITEMS = 10;

export const toGalleryView = (value: unknown): GalleryView =>
	GALLERY_VIEWS.includes(value as GalleryView) ? (value as GalleryView) : DEFAULT_GALLERY_VIEW;

export const resolveGalleryView = (value: unknown, isPrint?: boolean): GalleryView =>
	isPrint ? "mosaic" : toGalleryView(value);
